import { Text } from "react-aria-components";

import { cn } from "@/utils/cn";

type ProgressBarProps = {
  /** Explicit CSS color for the filled portion. Overrides the default tint. */
  fillColor?: string;
  /** Show the numeric value next to the bar. Defaults to true. */
  showValue?: boolean;
  value: number;
};

export function ProgressBar({
  fillColor,
  showValue = true,
  value,
}: ProgressBarProps) {
  return (
    <div className="w-full min-w-[200px] flex items-center gap-1">
      <div className="h-2 w-full rounded-md bg-gray-200 overflow-hidden relative">
        <div
          className={cn(
            "h-2 w-full rounded-md absolute transition-[width] duration-300 ease-linear",
            !fillColor && "bg-bg-brand-primary",
          )}
          style={{
            backgroundColor: fillColor,
            width: `${value}%`,
          }}
        ></div>
      </div>
      {showValue ? (
        <Text className="text-md text-text-secondary">{value}%</Text>
      ) : null}
    </div>
  );
}
